var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickProcessGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m189.66,97.92c0-49.55-40.22-89.87-89.66-89.87-23,0-43.99,8.73-59.88,23.04l10.32,11.52c13.15-11.85,30.53-19.07,49.56-19.07,40.91,0,74.2,33.36,74.2,74.37,0,27.38-14.85,51.34-36.89,64.25l-5.36-10.02-17.52,26.86,36.58,8.78-6.4-11.96c26.89-15.53,45.04-44.63,45.04-77.91Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m46.2,169.76c6.54,4.93,13.78,8.99,21.53,12l5.8-14.37c-6.59-2.53-12.74-5.98-18.28-10.19l-9.05,12.56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m25.8,97.92c0-.86.02-1.71.05-2.56l-15.45-.58c-.04,1.04-.06,2.09-.06,3.15,0,8.47,1.18,16.68,3.37,24.46l14.2-6.82c-1.38-5.65-2.11-11.56-2.11-17.63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m18.26,134.83c3.45,7.65,7.94,14.72,13.29,21.05l11.65-10.17c-4.97-5.92-9.03-12.63-11.98-19.91l-12.96,9.03Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m39.44,54.98l-12.62-8.94c-6.81,9.62-11.78,20.64-14.39,32.53l14.95,4.03c2.12-10.11,6.29-19.47,12.06-27.62Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m100,172.29c-4.36,0-8.62-.38-12.78-1.11l-2.86,15.23c5.08.9,10.31,1.37,15.64,1.37,2.65,0,5.26-.12,7.85-.35l-4.85-15.21c-1,.04-2,.07-3,.07Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m124.04,139.76c-2.32,0-4.5-.9-6.14-2.54l-27.08-25.88c-1.64-1.64-2.54-3.82-2.54-6.14v-61.33c0-4.79,3.9-8.69,8.69-8.69s8.69,3.9,8.69,8.69v57.73l24.53,23.34c3.39,3.39,3.39,8.9,0,12.28-1.64,1.64-3.82,2.54-6.14,2.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickProcessGray);
export default __webpack_public_path__ + "static/media/quick-process-gray.28259c1972a2ab73ed2268fe1dddbb0b.svg";
export { ForwardRef as ReactComponent };